import React from 'react';

import { ENV_OVERRIDE_STORAGE_KEY } from '@/config/constants';
import { useLocalStorage } from 'react-use';

import { Environment, EnvironmentContext, Environments } from '.';
import { getEnvironment } from './config';

const PACKAGE = 'EnvironmentProvider';

type EnvironmentProviderProps = {
	environment?: Environment;
};

export const EnvironmentProvider: React.FC<EnvironmentProviderProps> = ({
	environment,
	children,
}) => {
	const [envOverride] = useLocalStorage<string>(ENV_OVERRIDE_STORAGE_KEY);
	const selectedEnvironment =
		environment === undefined ? getEnvironment(envOverride) : environment;

	return (
		<EnvironmentContext.Provider value={selectedEnvironment}>
			{children}
		</EnvironmentContext.Provider>
	);
};

export default EnvironmentProvider;
